import { Component, Host, h, Element, Prop } from '@stencil/core';
import { Size } from '../aha-pill/types';

export interface AhaScorePill extends HTMLAhaScorePillElement {}

/**
 * A pill showing a product value score.
 */
@Component({
  tag: 'aha-score-pill',
  styleUrl: 'aha-score-pill.css',
  shadow: true,
})
export class AhaScorePill {
  @Element() host!: HTMLAhaScorePillElement;

  /**
   * The product value score to display.
   *
   * This accepts a number and will return it with proper localized formatting.
   * For example, a score of 1000 will be rendered as 1,000
   */
  @Prop() score!: number;

  @Prop() size?: Size = 'medium';

  /**
   * Have a different hover style when the score is clickable.
   */
  @Prop() clickable?: boolean;

  render() {
    return (
      <Host>
        <aha-pill color="var(--theme-tertiary-background)" border-shape="round" size={this.size}>
          <div class="wrapper">
            <aha-icon icon="aha-icon-product-value-score"></aha-icon>
            <span>{this.score.toLocaleString()}</span>
          </div>
        </aha-pill>
      </Host>
    );
  }
}
